import store from '@/store/index.js'
// import { requestModule.postRequest } from '@/assets/libs/requestModule'
import requestModule from '../libs/requestModule'

const getCardStatus = async function () {
  const { CDCONSUMIDOR } = store.getters.getCurrDependent
  const cardStatus = (await requestModule.postRequest('getCardStatus', { CDCONSUMIDOR }))?.data
  return cardStatus
}

const toggleCardStatus = async function (status) {
  const { CDCONSUMIDOR } = store.getters.getCurrDependent
  const newStatus = status === '1' ? 2 : 1
  const cardStatus = (await requestModule.postRequest('toggleCardStatus', { CDCONSUMIDOR, newStatus }))?.data
  return cardStatus
}

const setCardStatus = async function (CDCONSUMIDOR, newStatus) {
  const cardStatus = (await requestModule.postRequest('toggleCardStatus', { CDCONSUMIDOR, newStatus }))?.data
  return cardStatus
}

const getFlagCards = function (number) {
  const cardNumber = number.replace(/[^0-9]+/g, '')

  const cards = {
    visa: /^4[0-9]{12}(?:[0-9]{3})/,
    mastercard: /^5[1-5][0-9]{14}/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    amex: /^3[47][0-9]{13}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
    elo: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
    aura: /^((?!504175))^((?!5067))(^50[0-9])/
  }
  let flag = ''
  Object.keys(cards).forEach(e => {
    const re = new RegExp(cards[e])
    if (re.test(cardNumber)) {
      flag = e
    }
  })
  return flag
}

const updateStoredCards = async function () {
  const cards = (await requestModule.postRequest('card/list', {}, null, 'get'))?.data
  store.dispatch('setCards', cards)
}

const registerNewCard = async function () {
  const newCreditCard = store.getters.newCardValues
  console.log('newCreditCard', newCreditCard)

  const payload = {
    name: newCreditCard.nomedotitular.trim(),
    number: newCreditCard.numerodocartao.replaceAll(' ', ''),
    expiration: newCreditCard.validade,
    flag: newCreditCard.flag,
    cvv: newCreditCard.cvv,
    main: newCreditCard.tornarestecartaoprincipal ? 'P' : 'O'
  }

  console.log('payload', payload)

  try {
    const result = (await requestModule.postRequest('card/save', payload))
    if (result && !result.error) {
      await updateStoredCards()
    } else {
      store.dispatch('showModalInfo', { type: 'error', text: result.message, open: true })
    }
    return result
  } catch (error) {
    store.dispatch('showModalInfo', { type: 'error', text: 'Erro ao cadastrar cartão', open: true })
    console.error('Error registering new card:', error)
    return {
      error: true,
      message: error?.response?.data?.message
    }
  }
}

const deleteCreditCard = async function (creditCard) {
  const payload = { identifier: creditCard.identifier }

  try {
    const result = (await requestModule.postRequest('card/delete', payload))?.data
    if (result && !result.error) {
      updateStoredCards()
      store.dispatch('showModalInfo', { type: 'success', text: 'Cartão deletado com sucesso', open: true })
    } else {
      store.dispatch('showModalInfo', { type: 'error', text: result.message, open: true })
    }
    return result
  } catch (error) {
    store.dispatch('showModalInfo', { type: 'error', text: error?.response?.data?.message, open: true })
    return {
      error: true,
      message: error?.response?.data?.message
    }
  }
}

const getUserCards = async function () {
  try {
    const cards = (await requestModule.postRequest('card/list', {}, null, 'get'))?.data
    store.dispatch('setCards', cards)
    return cards
  } catch (error) {
    store.dispatch('showModalInfo', { type: 'error', text: 'Erro ao buscar cartões', open: true })
    return {
      error: true,
      message: error?.response?.data?.message
    }
  }
}

export {
  getCardStatus,
  toggleCardStatus,
  setCardStatus,
  getFlagCards,
  registerNewCard,
  updateStoredCards,
  deleteCreditCard,
  getUserCards
}
